import React, { useState } from 'react';
import p, { langcode } from 'translation';
import { LinkProps, Link } from 'react-router-dom';
import { Button, Checkbox, FormControlLabel } from '@mui/material';

const NextPage = React.forwardRef<any, LinkProps>((props, ref) => (
  <Link ref={ref} {...props} />
));

function toWebCountry(): string {
  switch (langcode) {
    case 'nb':
      return 'no';
    case 'sv':
      return 'se';
    case 'en':
    default:
      return 'uk';
  }
}

export default function TermsAndConditions(): JSX.Element {
  const [tandc, setTandc] = useState<boolean>(false);
  const [privacy, setPrivacy] = useState<boolean>(false);

  return (
    <main>
      <article>
        <h1>{p.t('pages.onboarding.tandc.title')}</h1>

        <section>
          <p>
            <a
              href='https://komp.family/terms-and-conditions'
              target='_blank'
              rel='noopener noreferrer'
            >
              {`→ ${p.t('pages.onboarding.tandc.read-tandc')}`}
            </a>
          </p>

          <FormControlLabel
            label={p.t('pages.onboarding.tandc.tandc-agreement')}
            control={
              <Checkbox
                color='primary'
                checked={tandc}
                onChange={e => setTandc(e.target.checked)}
              />
            }
          />
        </section>

        <section>
          <p>
            <a
              href='/privacy-statement/2020-08-24.pdf'
              target='_blank'
              rel='noopener noreferrer'
            >
              {`→ ${p.t('pages.onboarding.tandc.read-privacy')}`}
            </a>
          </p>

          <FormControlLabel
            label={p.t('pages.onboarding.tandc.privacy-agreement')}
            control={
              <Checkbox
                color='primary'
                checked={privacy}
                onChange={e => setPrivacy(e.target.checked)}
              />
            }
          />
        </section>
      </article>
      <Button
        color='primary'
        variant='contained'
        component={NextPage}
        to='/signup/create-profile'
        disabled={!tandc || !privacy}
      >
        {p.t('pages.onboarding.tandc.next')}
      </Button>
    </main>
  );
}
